import React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { SapCtaBanner } from '#src/app/shared/components/banners/sapCta';

import { useCtaSection } from './hooks';

export const CtaSection: React.FC<EmptyProps> = () => {
	const {
		actions: { trackSapClick },
	} = useCtaSection();

	return (
		<SapCtaBanner
			headingKey={translationKey('corgi.location_page_sitemap.cta.cta_section_text')}
			buttonKey={translationKey('corgi.location_page_sitemap.cta.cta_button')}
			sourceLocation="location_sitemap"
			className="flex flex-col p-10 max-lg:gap-10 md:flex-row md:items-center md:justify-between"
			buttonQa="sidebar-sap-button"
			onButtonClick={trackSapClick}
		/>
	);
};
